// extracted by css-extract-rspack-plugin
export default {"scrollbarContainer":"scrollbarContainer-dumSAF","scrollbarInner":"scrollbarInner-cyB9zu","scrollbarInput":"scrollbarInput-bh8ySO"};